import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Container from "@material-ui/core/Container";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import HomeIcon from "@material-ui/icons/Home";
import Link from "@material-ui/core/Link";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  link: {
    display: "flex",
    fontWeight: 500,
    padding: "8px 14px",
    transitionProperty: "background,border-radius,box-shadow,border,color",
    transitionDuration: ".2s,.2s,.2s,.2s,.2s",
    "&:hover": {
      backgroundColor: "#ebeeff",
      color: "#414dd4",
      backgroundClip: "padding-box",
      borderRadius: 4,
      textDecoration: "none",
    },
    "&:focus": {
      backgroundColor: "#ebeeff",
      color: "#414dd4",
      backgroundClip: "padding-box",
      borderRadius: 4,
      textDecoration: "none",
    },
    "&:active": {
      backgroundColor: "#bfc4ff",
      backgroundClip: "padding-box",
      borderRadius: 4,
      color: "#414dd4",
    },
  },
  activeLink: {
    display: "flex",
    fontWeight: 700,
    padding: "8px 14px",
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
  main: {
    backgroundColor: "#F5F9FF",
  },
  cardGrid: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(8),
  },
  scrubberImg: {
    marginTop: "-1%",
    paddingBottom: 1,
    ["@media (max-width:768px)"]: { // eslint-disable-line no-useless-computed-key
      display: 'none',
    },
  },
  listRoot: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    position: "relative",
    overflow: "auto",
    marginTop: 32,
    maxHeight: 355,
    borderRadius: 4,
    boxShadow:
      "0 0 1px 1px rgb(45 52 69 / 5%), 0 1px 3px 0 rgb(45 52 69 / 15%)",
    outline: "1px solid transparent",
    cursor: "default",
    "&::-webkit-scrollbar": {
      "-webkit-appearance": "none",
      width: 7,
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: 4,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      "-webkit-box-shadow": "0 0 1px rgba(255, 255, 255, 0.5)",
    },
    ["@media (max-width:959px)"]: { // eslint-disable-line no-useless-computed-key
      marginTop: 0,
    },
  },
  listSection: {
    backgroundColor: "inherit",
  },
  ul: {
    backgroundColor: "inherit",
    padding: 0,
  },
}));

function EventCardDetailed({ events, match }) {
  const classes = useStyles();
  const findEvent = events.find(
    ({ sku }) => sku === match.params.sku.toUpperCase()
  );
  const { sku, name, image, type, personalizable, requirements, assets } =
    findEvent;
  const baseScrubberBarImage =
    "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/images/scrubber-bar-";

  return (
    <main className={classes.main}>
      <Container className={classes.cardGrid} maxWidth="md">
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Breadcrumbs
              separator={<NavigateNextIcon />}
              aria-label="breadcrumb"
            >
              <Link color="primary" href="#/" className={classes.link}>
                <HomeIcon className={classes.icon} />
                CTA Catalog
              </Link>
              <Typography color="textPrimary" className={classes.activeLink}>
                {sku} {personalizable ? "(Personalized)" : ""}
              </Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography variant="h6" color="textPrimary">
              {name}
            </Typography>
            <img src={image} width="100%" alt={name + " image"}></img>
            <img
              src={baseScrubberBarImage + type + ".png"}
              width="100%"
              alt="Scrubber Bar"
              className={classes.scrubberImg}
            ></img>
          </Grid>
          <Grid item xs={12} md={4}>
            <List className={classes.listRoot} subheader={<li />}>
              {["Requirements", "Assets"].map((sectionId) => (
                <li
                  key={`section-${sectionId.toLowerCase()}`}
                  className={classes.listSection}
                >
                  <ul className={classes.ul}>
                    <ListSubheader color="primary" style={{ fontSize: "1rem" }}>
                      {sectionId}
                    </ListSubheader>

                    {/* Not Ideal - Page will break if the events.js doesn't have both requirements and assets inside each event as an object */}
                    {(sectionId === "Requirements"
                      ? requirements
                      : sectionId === "Assets"
                      ? assets
                      : ""
                    ).map((item, i) => (
                      <ListItem key={`item-${sectionId.toLowerCase()}-${i}`}>
                        <ListItemText secondary={`${item}`} />
                      </ListItem>
                    ))}
                  </ul>
                </li>
              ))}
            </List>
          </Grid>
        </Grid>
      </Container>
      <Divider variant="middle" />
    </main>
  );
}

export default EventCardDetailed;
